import React from "react";
import "./FAQ.css";

const faqs = [
  {
    question: "Who can request support?",
    answer:
      "Any parent or caregiver navigating a NICU or early-preemie journey is welcome to request support. We are here for families who need practical help during an unexpected beginning."
  },
  {
    question: "What kinds of support do you offer?",
    answer:
      "We can help connect families with grocery and gas funds, care items such as diapers, clothes, pacifiers, and bottles, and other resources that ease the burden of early recovery and caregiving."
  },
  {
    question: "How do I request support?",
    answer:
      "Use the Request support form under the Support menu or send us an email at families@bugandfrog.org and we'll reach out as soon as possible!"
  },
  {
    question: "Is this a one-time request or ongoing support?",
    answer:
      "Support is tailored to each family and their needs. Some families may need a one-time package or resource, while others may need general guidance or additional follow-up."
  },
  {
    question: "How can I donate?",
    answer: "Donations are currently only open in the state of Georgia. We're working on bringing our outreach to other states!"
  },
   {
    question: "How can I volunteer?",
    answer: "We're so glad you're interested in supporting our mission! If you knit, crochet, sew, or craft, join Busy Bees, our volunteer program making items for NICU babies, by emailing volunteer@bugandfrog.org. Other volunteer inquiries can be sent to info@bugandfrog.org; please give 1-2 days for a response."
  }
];

export default function FAQ() {
  return (
    <div className="faq-page">
      <section className="page-hero">
        <div className="container">
          <h1>Frequently asked questions</h1>
        </div>
      </section>

      <section>
        <div className="container faq-list">
          {faqs.map((item) => (
            <div className="faq-item" key={item.question}>
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
